'use strict';

var _ = require('underscore');

module.exports = function(object, path, value) {
	var keys = path.split('.');

	var subObject = _(keys)
		.chain()
		.initial()
		.reduce(
			function(object, key) {
				var subObject = object[key];

				if (!_(subObject).isObject()) {
					subObject = object[key] = {};
				}

				return subObject;
			},
			object
		)
		.value();

	subObject[_(keys).last()] = value;

	return object;
};
